// import React from 'react';
// import { Helmet } from "react-helmet";
// import { Row, Col, Card } from "react-bootstrap";
// import BankRoll from "../../components/Game/BankRoll";
// import Queue from "../../components/Game/Queue";
// import TopBarGames from "../../components/Game/Addons/TopBar";
// import Engine from "./Engine";
// import Game from "./Game";
// import Bet from "./Bet";
// import { isMobile, wait, Event } from 'utils/Helper';
// import MinePopup from './Graph';

// class Main extends React.Component {
//     _Mounted = false;
//     constructor(props) {
//         super(props);
//         this.state = {
//             engine: new Engine(),
//             padding: "p-1",
//             showPopup: false
//         };
//         this.handleShowPopUp = this.handleShowPopUp.bind(this);
//         this.handleResize = this.handleResize.bind(this);
//     }

//     handleShowPopUp() {
//         this.setState((prevState) => ({
//             showPopup: !prevState.showPopup
//         }));
//     }

//     componentDidMount() {
//         this._Mounted = true;
//         let { engine } = this.state;

//         document.body.scrollTop = 0;
//         document.documentElement.scrollTop = 0;

//         // Start Engine
//         engine.started = true;

//         wait(10).then(() => {
//             this.handleResize();
//         });
//         window.addEventListener('resize', this.handleResize);
//     }

//     componentWillUnmount() {
//         let { engine } = this.state;
//         window.removeEventListener('resize', this.handleResize);
//         this._Mounted = false;

//         // Stop Engine
//         engine.started = false;
//         engine.trigger = null;
//         engine.off()
//     }

//     handleResize() {
//         let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;

//         if (clientWidth < 1540) {
//             this.setState({ col: 'col-xl-12' });
//             Event.emit('hide_games');
//         }
//         else {
//             this.setState({ col: 'col-xl-9' });
//             Event.emit('show_min_games');
//         }
//         if (isMobile()) {
//             this.setState({ padding: 'p-0', ovh: 'ovh' });
//         }
//     }

//     render() {
//         let { col, padding, ovh } = this.state;

//         const help = <><p className={'font-light text-white font-15'}>
//             Mines is a game of guessing and luck. You will first need to select a bet amount and the number of mines. The higher the mine value, the higher the payout. Once you have selected the number of mines and your bet amount you will place your bet. You will click each space, taking the chance of hitting a mine, or winning that value. You can cash out at any time!
//         </p>
//             <b>Players Tips & Tricks</b>
//             <p className={'font-light text-white font-15'}>*These tips are submitted by actual players, so please consider with caution.
//                 Choose all 4 corners! <br />
//                 I go in a diagonal pattern, and I don’t choose more than 4 squares, then it gets a little risky.
//                 I always go with the center and 4 corners, seems to be lucky most of the time.
//             </p>
//             <h4 className="text-white text-success">
//                 How Can Calculate Profit ?
//             </h4>
//             <p className={'font-light text-white font-15'}>
//                 For the each clicked on the lands, number of mines multiplied by amount of the bet and result was divided by 10: <span className="text-secondary">(bet * mines) / 10</span>
//             </p></>;
//         return (
//             <>
//                 <Helmet>
//                     <title>Mine</title>
//                     <meta name="keywords" content="Crypto Mine Game, Online Mine Game, Bitcoin Mine Game, Blockchain Mine Game, Best Crypto Mine Game, PlayCrash.com Mine" />
//                     <meta name="description" content="Crypto Mines is a game of guessing and luck. You will first need to select a bet amount and the number of mines. The higher the mine value, the higher the payout. Once you have selected the number of mines and your bet amount you will place your bet" />
//                     <meta name="og:title" content="Play Online Mine - Play with INR, ETH LTC, USDT, BCH, TRX and many more !" />
//                     <meta name="og:description" content="Play Online Mine - Play with INR, ETH LTC, USDT, BCH, TRX and many more !" />
//                     <link rel="canonical" href="/mine" />
//                 </Helmet>
//                 <div>
//                 <div className={`${col} ${padding}`} style={{ position: 'relative', width: '100%',border:"2px solid red", height: '100%' }}>
//                             {this.state.showPopup && (
//                                 <MinePopup
//                                     onClose={this.handleShowPopUp}
//                                     engine={this.state.engine}
//                                 />
//                             )}
//                     <Row className={"animated fadeIn " + ovh} style={{border:"2px solid green"}}>
//                         <div className="d-none">Crypto Mine Game Description: {help}</div>
//                         <Col sm={12} className={'m-auto ' + col + ' ' + padding}>

//                             {/* MENUS */}
//                             <Card className="mb-0">
//                                 <Card.Body className="px-2 py-3">
//                                     <Row>
//                                         <Col md={6} className={'col-6 text-left'}>
//                                             <BankRoll game={'mine'} />
//                                         </Col>
//                                         <div style={{ display: 'flex' }}>

//                                                     <Col md={6} className={'col-6 text-right'}>
//                                                         <TopBarGames help={help} image="/assets/images/covers_new/____hilo.png" />
//                                                     </Col>
//                                                     <div onClick={this.handleShowPopUp} style={{ marginLeft: '26px', alignItems: 'center', height: '37px', width: '37px', borderRadius: '5px', backgroundColor: "#1B2336", display: 'flex', justifyContent: 'center',border:"2px solid blue" }}>
//                                                         <img style={{ height: '17px', width: '17px' }} src="/assets/images/nanoicons/nanoswap.png" alt="Swap" />

//                                                     </div>
//                                                 </div>
//                                     </Row>
//                                 </Card.Body>
//                             </Card>

//                             {this._Mounted ?
//                                 <>
//                                     {/* GAME */}
//                                     < Card className="mb-0">
//                                         <Card.Body className={'bg-mine-options p-1'} id="roll-panel">
//                                             <Row>
//                                                 <Col sm={12} md={10} className={'m-auto'}>
//                                                     <Game engine={this.state.engine} />
//                                                 </Col>
//                                             </Row>
//                                         </Card.Body>
//                                     </Card>
//                                 </>
//                                 :
//                                 < Card className="mb-0">
//                                     <Card.Body className={'bg-mine-options p-1'} id="roll-panel">
//                                         <Row>
//                                             <Col sm={12} md={10} className={'m-auto'}>
//                                                 <div className="game-loader  l-2 text-center">
//                                                     <div className="spinner-grow text-info my-3" role="status" />
//                                                 </div>
//                                             </Col>
//                                         </Row>
//                                     </Card.Body>
//                                 </Card>
//                             }

//                             {/* BETS */}
//                             <Card className="mb-0">
//                                 <Card.Body className={padding}>
//                                     <Row>
//                                         <Col sm={12} md={10} className={'m-auto'}>
//                                             <Bet engine={this.state.engine} />
//                                         </Col>
//                                     </Row>
//                                 </Card.Body>
//                             </Card>

//                             {/* QUEUE */}
//                             <Card className="mb-5">
//                                 <Card.Body className="p-1">
//                                     <Row>
//                                         <Col sm={12} md={12} className={'m-auto px-1'}>
//                                             <Queue t={this.props.t} game={'mine'} />
//                                         </Col>
//                                     </Row>
//                                 </Card.Body>
//                             </Card>

//                         </Col>
//                     </Row>
//                     </div>
//                 </div>
//             </>
//         );
//     }
// }

// export default Main;



// Vivek

// import React from 'react';
// import { Helmet } from "react-helmet";
// import { Row, Col, Card } from "react-bootstrap";
// import BankRoll from "../../components/Game/BankRoll";
// import Queue from "../../components/Game/Queue";
// import TopBarGames from "../../components/Game/Addons/TopBar";
// import Engine from "./Engine";
// import Game from "./Game";
// import Bet from "./Bet";
// import { isMobile, wait, Event } from 'utils/Helper';
// import MinePopup from './Graph';
// import styled from 'styled-components';

// // Styled component with media queries
// const MinesContainer = styled.div`
//   display: flex;
// //   flex-direction: column;
//   border: 5px solid blue;

//   @media (max-width: 1200px) {  // Medium screens (like tablets and small laptops)
//     flex-direction: row;
//   }

//   @media (max-width: 768px) {   // Small screens (mobile devices)
//     flex-direction: row;
//   }
// `;

// class Main extends React.Component {
//     _Mounted = false;
//     constructor(props) {
//         super(props);
//         this.state = {
//             engine: new Engine(),
//             padding: "p-1",
//             showPopup: false
//         };
//         this.handleShowPopUp = this.handleShowPopUp.bind(this);
//         this.handleResize = this.handleResize.bind(this);
//     }

//     handleShowPopUp() {
//         this.setState((prevState) => ({
//             showPopup: !prevState.showPopup
//         }));
//     }

//     componentDidMount() {
//         this._Mounted = true;
//         let { engine } = this.state;

//         document.body.scrollTop = 0;
//         document.documentElement.scrollTop = 0;

//         // Start Engine
//         engine.started = true;

//         wait(10).then(() => {
//             this.handleResize();
//         });
//         window.addEventListener('resize', this.handleResize);
//     }

//     componentWillUnmount() {
//         let { engine } = this.state;
//         window.removeEventListener('resize', this.handleResize);
//         this._Mounted = false;

//         // Stop Engine
//         engine.started = false;
//         engine.trigger = null;
//         engine.off()
//     }

//     handleResize() {
//         let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;

//         if (clientWidth < 1540) {
//             this.setState({ col: 'col-xl-12' });
//             Event.emit('hide_games');
//         }
//         else {
//             this.setState({ col: 'col-xl-9' });
//             Event.emit('show_min_games');
//         }
//         if (isMobile()) {
//             this.setState({ padding: 'p-0', ovh: 'ovh' });
//         }
//     }

//     render() {
//         let { col, padding, ovh } = this.state;

//         const help = <><p className={'font-light text-white font-15'}>
//             Mines is a game of guessing and luck. You will first need to select a bet amount and the number of mines. The higher the mine value, the higher the payout. Once you have selected the number of mines and your bet amount you will place your bet. You will click each space, taking the chance of hitting a mine, or winning that value. You can cash out at any time!
//         </p>
//             <b>Players Tips & Tricks</b>
//             <p className={'font-light text-white font-15'}>*These tips are submitted by actual players, so please consider with caution.
//                 Choose all 4 corners! <br />
//                 I go in a diagonal pattern, and I don’t choose more than 4 squares, then it gets a little risky.
//                 I always go with the center and 4 corners, seems to be lucky most of the time.
//             </p>
//             <h4 className="text-white text-success">
//                 How Can Calculate Profit ?</h4>
//             <p className={'font-light text-white font-15'}>
//                 For the each clicked on the lands, number of mines multiplied by amount of the bet and result was divided by 10: <span className="text-secondary">(bet * mines) / 10</span>
//             </p></>;

//         return (
//             <>
//                 <Helmet>
//                     <title>Mine</title>
//                     <meta name="keywords" content="Crypto Mine Game, Online Mine Game, Bitcoin Mine Game, Blockchain Mine Game, Best Crypto Mine Game, PlayCrash.com Mine" />
//                     <meta name="description" content="Crypto Mines is a game of guessing and luck. You will first need to select a bet amount and the number of mines. The higher the mine value, the higher the payout. Once you have selected the number of mines and your bet amount you will place your bet" />
//                     <meta name="og:title" content="Play Online Mine - Play with INR, ETH LTC, USDT, BCH, TRX and many more !" />
//                     <meta name="og:description" content="Play Online Mine - Play with INR, ETH LTC, USDT, BCH, TRX and many more !" />
//                     <link rel="canonical" href="/mine" />
//                 </Helmet>
//                 <div>
//                     <div className={`${col} ${padding}`} style={{ position: 'relative', width: '100%', height: '100%' }}>
//                         {this.state.showPopup && (
//                             <MinePopup
//                                 onClose={this.handleShowPopUp}
//                                 engine={this.state.engine}
//                             />
//                         )}
//                         <Col className={"animated fadeIn " + ovh}>
//                             <div className="d-none">Crypto Mine Game Description: {help}</div>
//                             <Col sm={12} className={'m-auto ' + col + ' ' + padding} >
//                                 <MinesContainer>
//                                     <div style={{ display: 'flex' }}>
//                                         {/* Left Side: Yellow Border */}
//                                         <div style={{ flex: 1, border: "2px solid yellow", alignItems: "left", justifyContent: "left" }}>
//                                             <Card className="mb-0">
//                                                 <Card.Body className={padding}>
//                                                     <Row>
//                                                         <Col sm={12} md={10} className={''}>
//                                                             <Bet engine={this.state.engine} />
//                                                         </Col>
//                                                     </Row>
//                                                 </Card.Body>
//                                             </Card>
//                                         </div>

//                                         {/* Right Side: Orange Border */}
//                                         <div style={{ flex: 2, border: "2px solid orange" }}>
                                          

//                                             {this._Mounted ? (
//                                                 <Card className="mb-0">
//                                                     <Card.Body className={'bg-mine-options p-1'} id="roll-panel">
//                                                         <Row>
//                                                             <Col sm={12} md={10} className={'m-auto'}>
//                                                                 <Game engine={this.state.engine} />
//                                                             </Col>
//                                                         </Row>
//                                                     </Card.Body>
//                                                       <Card className="mb-0" style={{ border: "2px solid pink" }}>
//                                                 <Card.Body className="px-2 py-3">
//                                                     <Row>
//                                                         <Col md={6} className={'col-6 text-left'}>
//                                                             <BankRoll game={'mine'} />
//                                                         </Col>
//                                                         <div style={{ display: 'flex' }}>
//                                                             <Col md={6} className={'col-6 text-right'}>
//                                                                 <TopBarGames help={help} image="/assets/images/covers_new/____hilo.png" />
//                                                             </Col>
//                                                             <div
//                                                                 onClick={this.handleShowPopUp}
//                                                                 style={{
//                                                                     marginLeft: '26px',
//                                                                     alignItems: 'center',
//                                                                     height: '37px',
//                                                                     width: '37px',
//                                                                     borderRadius: '5px',
//                                                                     backgroundColor: "#1B2336",
//                                                                     display: 'flex',
//                                                                     justifyContent: 'center',
//                                                                     border: "2px solid blue"
//                                                                 }}
//                                                             >
//                                                                 <img style={{ height: '17px', width: '17px' }} src="/assets/images/nanoicons/nanoswap.png" alt="Swap" />
//                                                             </div>
//                                                         </div>
//                                                     </Row>
//                                                 </Card.Body>
//                                             </Card>
//                                                 </Card>
                                                
//                                             ) : (
//                                                 <Card className="mb-0" style={{ border: "2px solid white" }}>
//                                                     <Card.Body className={'bg-mine-options p-1'} id="roll-panel">
//                                                         <Row>
//                                                             <Col sm={12} md={10} className={'m-auto'}>
//                                                                 <div className="game-loader l-2 text-center">
//                                                                     <div className="spinner-grow text-info my-3" role="status" />
//                                                                 </div>
//                                                             </Col>
//                                                         </Row>
//                                                     </Card.Body>
//                                                 </Card>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </MinesContainer>

//                                 {/* QUEUE */}
//                                 <Card className="mb-5" style={{ border: "2px solid purple" }}>
//                                     <Card.Body className="p-1">
//                                         <Row>
//                                             <Col sm={12} md={12} className={'m-auto px-1'}>
//                                                 <Queue t={this.props.t} game={'mine'} />
//                                             </Col>
//                                         </Row>
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                         </Col>
//                     </div>
//                 </div>
//             </>
//         );
//     }
// }

// export default Main;


import React from 'react';
import { Helmet } from "react-helmet";
import { Row, Col, Card } from "react-bootstrap";
import BankRoll from "../../components/Game/BankRoll";
import Queue from "../../components/Game/Queue";
import TopBarGames from "../../components/Game/Addons/TopBar";
import Engine from "./Engine";
import Game from "./Game";
import Bet from "./Bet";
import { isMobile, wait, Event } from 'utils/Helper';
import MinePopup from './Graph';



class Main extends React.Component {
    _Mounted = false;
    constructor(props) {
        super(props);
        this.state = {
            engine: new Engine(),
            padding: "p-1",
            showPopup: false
        };
        this.handleShowPopUp = this.handleShowPopUp.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    handleShowPopUp() {
        this.setState((prevState) => ({
            showPopup: !prevState.showPopup
        }));
    }

    componentDidMount() {
        this._Mounted = true;
        let { engine } = this.state;

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        // Start Engine
        engine.started = true;

        wait(10).then(() => {
            this.handleResize();
        });
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        let { engine } = this.state;
        window.removeEventListener('resize', this.handleResize);
        this._Mounted = false;

        // Stop Engine
        engine.started = false;
        engine.trigger = null;
        engine.off()
    }

    handleResize() {
        let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;

        if (clientWidth < 1540) {
            this.setState({ col: 'col-xl-12' });
            Event.emit('hide_games');
        }
        else {
            this.setState({ col: 'col-xl-9' });
            Event.emit('show_min_games');
        }
        if (isMobile()) {
            this.setState({ padding: 'p-0', ovh: 'ovh' });
        }
    }

    

    render() {
        let { col, padding, ovh } = this.state;

        const help = <><p className={'font-light text-white font-15'}>
            Mines is a game of guessing and luck. You will first need to select a bet amount and the number of mines. The higher the mine value, the higher the payout. Once you have selected the number of mines and your bet amount you will place your bet. You will click each space, taking the chance of hitting a mine, or winning that value. You can cash out at any time!
        </p>
            <b>Players Tips & Tricks</b>
            <p className={'font-light text-white font-15'}>*These tips are submitted by actual players, so please consider with caution.
                Choose all 4 corners! <br />
                I go in a diagonal pattern, and I don’t choose more than 4 squares, then it gets a little risky.
                I always go with the center and 4 corners, seems to be lucky most of the time.
            </p>
            <h4 className="text-white text-success">
                How Can Calculate Profit ?
            </h4>
            <p className={'font-light text-white font-15'}>
                For the each clicked on the lands, number of mines multiplied by amount of the bet and result was divided by 10: <span className="text-secondary">(bet * mines) / 10</span>
            </p></>;

            
        return (
            <>
                <Helmet>
                    <title>Mine</title>
                   
                    <link rel="canonical" href="/mine" />
                </Helmet>
                <div>
                <div className={`${col} ${padding}`} style={{ position: 'relative', width: '100%', height: '100%' }}>
                            {this.state.showPopup && (
                                <MinePopup
                                    onClose={this.handleShowPopUp}
                                    engine={this.state.engine}
                                />
                            )}
                    <Row className={"animated fadeIn " + ovh}>
                        <div className="d-none">Crypto Mine Game Description: {help}</div>
                        <Col sm={12} className={'m-auto ' + col + ' ' + padding}>
 {/* <div 
    style={{
        width: "100%", 
        height: "100%", 
        padding: "20px 10px", 
        backgroundColor: "black", 
        display: "flex", 
       
        
    }}
>

    <div style={{
        border:"2px solid green",
         width:"100%",
          height:"100%",
          display:"flex",
          justifyContent: "space-around", 
          alignItems: "center", 
          gap:"10px"
          
          }}>
          
    <div 
        style={{
            border: "2px solid blue", 
            borderRadius: "2rem", 
            width: "100%", 
            height: "100%", 
            display: "flex", 

            flexDirection: "column", 
            justifyContent: "center", 
            alignItems: "center", 
            textAlign: "center", 
            color: "white", 
            // padding: "4px 0px",
            flex:"1"
        }}
    >
        <p style={{
            justifyContent:"center",
            alignItems:"center",
            textAlign:"center",
            padding:"5px 0",
            border:"2px solid red"
        }}>
        <span style={{margin: "0", fontSize: "13px", color: "green"}}>
            BankRoll
        </span>
        <span style={{margin: "5px 0", fontSize: "12px", color: "white"}}>
            INR
        </span>
        <p style={{margin: "0", fontSize: "12px", fontWeight: "bold"}}>
            280342.002
        </p>

        </p>
       
    </div>

    
    <div 
        style={{
            border: "2px solid yellow", 
            borderRadius: "2rem", 
            width: "100%", 
            height: "100%", 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            textAlign: "center", 
            color: "white", 
            fontSize: "18px",
            padding:"4px",
            flex:"2"
        }}
    >
        mehra
    </div>


    </div>
  
</div> */}

{/* mine-container */}  

<div className='mine-containers'>
{/* game container */}

<div className='game-containers'>
    
                                <div 
                                className='game-header'
                                style={{
                                    // width: "100%", 
                                    // height: "100%",  // Use 100vh for full viewport height
                                    padding: "3px 10px", 
                                    backgroundColor: "#17181b", 
                                    display: "flex", 
                                    justifyContent: "center",  // Center the container horizontally
                                    alignItems: "center",      // Center the container vertically
                                    boxSizing: "border-box",   // Ensure padding doesn't affect the width/height
                                    opacity:0.9,
                                    // borderTopLeftRadius: "1rem",  // Top-left corner rounded
                                    borderTopRightRadius: "1rem", // Top-right corner rounded
                                    
                                }}
                            >

                                <div style={{
                                    width: "100%",
                                    height: "auto", 
                                    display: "flex",
                                    justifyContent: "space-around", 
                                    alignItems: "center", 
                                    gap: "10px",
                                    // border:"2px solid red",   // Allow wrapping on smaller screens
                                }}>
                                    {/* First Circle */}
                                    <div 
                                    className='header-content'
                                style={{
                                    borderRadius: "2rem",  // Ensure it is circular
                                    width: "100%",         // Adjust width as a percentage for responsiveness
                                    height: "100%",      // Fixed height for the div
                                    display: "flex", 
                                    flexDirection: "column", 
                                    justifyContent: "center", // Vertically centers content
                                    alignItems: "center", // Horizontally centers content
                                    textAlign: "center", 
                                    color: "white", 
                                    boxSizing: "border-box",
                                    flex: "2",
                                    padding:"5px",
                                    // overflow:"hidden",
                                    whiteSpace: "nowrap",       // Prevent text from wrapping
                                    textOverflow: "ellipsis", 
                                }}
                            >
                               
                                    </div>

                                    {/* Second Circle */}
                                    {/* <div 
                                        style={{
                                            // border: "2px solid yellow", 
                                            borderRadius: "2rem",  // Ensure it is circular
                                            width: "100%",         // Adjust width as a percentage for responsiveness
                                            height: "100%",      // Fixed height, same as above for uniformity
                                            display: "flex", 
                                            justifyContent: "center", 
                                            alignItems: "center", 
                                            textAlign: "center", 
                                            color: "white", 
                                            fontSize: "15px",
                                            fontWeight:"bold",
                                            padding: "13px",
                                            boxSizing: "border-box",
                                            flex:"3",
                                            backgroundColor: "#26272c",
                                            color:"gray",
                                            overflow:"hidden"
                                        }}
                                        className='fontChange'
                                    >
                            
                                Game results will be displayed here.
                                
                                    </div> */}
                                  

                                </div>
                            </div>

                            {this._Mounted ?
                                <>
                                    {/* GAME */}
                                    <Card 
                                className="mb-0" 
                                style={{
                                    backgroundImage: "url(/assets/images/minesbackground.png)",
                                    backgroundSize: "cover",    // Ensures the image covers the whole card
                                objectFit:"cover",
                                    width:"100%",
                                    backgroundPosition: "center", // Centers the image
                                    // opacity:"0.6",
                                    backgroundRepeat: "no-repeat" // Prevents image repetition if smaller than the card
                                }}
                                >
                                <Card.Body className={'bg-mine-options p-1'} id="roll-panel" 
                                    style={{
                                        backgroundColor: "rgba(0, 0, 0, 0.1)", // Optional: Adjusts transparency of the background color, if needed
                                    }}
                                >
                                    <Row>
                                    <Col sm={12} md={10} className={'m-auto'}>
                                        <Game engine={this.state.engine} />
                                    </Col>
                                    </Row>
                                </Card.Body>
                                </Card>

                                </>
                                :
                                < Card className="mb-0">
                                    <Card.Body className={'bg-mine-options p-1'} id="roll-panel">
                                        <Row>
                                            <Col sm={12} md={10} className={'m-auto'}>
                                                <div className="game-loader  l-2 text-center">
                                                    <div className="spinner-grow text-info my-3" role="status" />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            }
</div>

{/* bet container */}

<div className='bet-containers'>
                            {/* BETS */}
                            <Card className="mb-0 bet-body" style={{backgroundColor:"#17181b", padding:"10px" ,height:"100%"}}>
                                <Card.Body className={padding}>
                                    <Row>
                                        <Col sm={12} md={12} className={'m-auto'} >
                                            <Bet engine={this.state.engine} />
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
</div>
</div>

                             {/* MENUS */}
                             <Card className="mb-0" style={{backgroundColor:"#17181b",
                            borderBottomLeftRadius:"1rem",
                            borderBottomRightRadius:"1rem",
                            
                             }}>
                                <Card.Body className="px-2 py-3">
                                    <Row>
                                        <Col md={6} className={'col-6 text-left'} >
                                            <BankRoll game={'mine'} />
                                        </Col>
                                        <div style={{ display: 'flex',justifyContent:"flex-end",right:"1px",width:"40%"}}>

                                                    <Col md={12} className={'col-12 '} style={{display:"flex",gap:"8px",justifyContent:"flex-end",textAlign:"center",justifyItems:"center",alignItems:"center"}} >
                                                        <TopBarGames help={help} image="/assets/images/covers_new/____hilo.png" />
                                                        <div
                                                     onClick={this.handleShowPopUp} 
                                                     style={{
                                                        //  marginLeft: '26px',
                                                          alignItems: 'center',
                                                           height: '37px',
                                                            width: '37px',
                                                            marginTop:"-2px",
                                                            //  borderRadius: '5px',
                                                            //   backgroundColor: "#1B2336",
                                                               display: 'flex',
                                                                justifyContent: 'center',
                                                                // border:"2px solid blue" 
                                                                }}>
                                                        <img style={{ 
                                                            height: '21px',
                                                             width: '21px'
                                                              }}
                                                             src="/assets/images/nanoicons/nanoswap.png" alt="Swap" />

                                                    </div>
                                                    </Col>
                                                  
                                                </div>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {/* QUEUE */}
                            <Card className="mb-5 mt-5" style={{borderRadius:"1rem",backgroundColor:"#17181b"}}>
                                <Card.Body className="p-1">
                                    <Row>
                                        <Col sm={12} md={12} className={'m-auto px-1'}>
                                            <Queue t={this.props.t} game={'mine'} />
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                        </Col>
                    </Row>
                    </div>
                </div>
            </>
        );
    }
}

export default Main;
